/********************************************************************************
Filename: np-responsive-video.js
Created: 15 Jul 2021
Author: Ron Robertson
Description: Displays differnt resolution video depending on browser width
Usage Example:
<np-responsive-video></np-responsive-video>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
          #np-responsive-video{
            width:100%;
            height:100%;
          }
            video{
                max-width:100%;
                max-height:100%;
                width:100%;
                height:100%;
            }

        </style>

        <div id="np-responsive-video">
            <video id="video" poster="" autoplay loop muted playsinline preload>
                <source id="source" type="video/mp4">
            </video>
        </div><!--END np-responsive-video-->
    `;

    class NpResponsiveVideo extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            this.addSourceToVideo = this.addSourceToVideo.bind(this);
            this.resizeEvent = this.resizeEvent.bind(this);
            this.adjustAfterResize = this.adjustAfterResize.bind(this);

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.npResponsiveVideo = this.shadowRoot.getElementById("np-responsive-video");
            this.video = this.shadowRoot.getElementById("video");
            this.source = this.shadowRoot.getElementById("source");

            //responsive breakpoints
            this.tinyBreakpoint=320;
            this.smallBreakpoint=480;
            this.mediumBreakpoint=768;
            this.largeBreakpoint=960;
            this.xlargeBreakpoint=1200;
            this.hdBreakpoint=1920;

            //tracks which breakpoint width is being used
            this.usingBreakpointWidth;

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            if (!this.hasAttribute('tinySrc')) {
                this.setAttribute('tinySrc', "");
            }
            /* Set default attribute value */
            if (!this.hasAttribute('smallSrc')) {
                this.setAttribute('smallSrc', "");
            }
            /* Set default attribute value */
            if (!this.hasAttribute('mediumSrc')) {
                this.setAttribute('mediumSrc', "");
            }
            /* Set default attribute value */
            if (!this.hasAttribute('largeSrc')) {
                this.setAttribute('largeSrc', "");
            }
            /* Set default attribute value */
            if (!this.hasAttribute('xlargeSrc')) {
                this.setAttribute('xlargeSrc', "");
            }
            /* Set default attribute value */
            if (!this.hasAttribute('hdSrc')) {
                this.setAttribute('hdSrc', "");
            }
            /* Set default attribute value */
            if (!this.hasAttribute('poster')) {
                this.setAttribute('poster', "");
            }

            /* Set Event Listeners */
            //this.myBtn.addEventListener('click', this.myMethod);

            //check if source should change on window resize
            window.addEventListener('resize', this.resizeEvent);

            this.determineVideoSrc();

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        static get observedAttributes() {
            return ['tinySrc','smallSrc','mediumSrc','largeSrc','xlargeSrc','hdSrc','poster'];
        }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {

        if(name === 'poster') {
            this.video.setAttribute("poster", newValue);
        }

       }/* END attributesChangedCallback */

      /* Getting attributes */
      get tinySrc() {
        return this.getAttribute('tinySrc');
      }
      get smallSrc() {
        return this.getAttribute('smallSrc');
      }
      get mediumSrc() {
        return this.getAttribute('mediumSrc');
      }
      get largeSrc() {
        return this.getAttribute('largeSrc');
      }
      get xlargeSrc() {
        return this.getAttribute('xlargeSrc');
      }
      get hdSrc() {
        return this.getAttribute('hdSrc');
      }
      get poster() {
        return this.getAttribute('poster');
      }

      /* Settinng attributes */
      set tinySrc(newValue) {
        this.setAttribute('tinySrc', newValue);
      }
      set smallSrc(newValue) {
        this.setAttribute('smallSrc', newValue);
      }
      set mediumSrc(newValue) {
        this.setAttribute('mediumSrc', newValue);
      }
      set largeSrc(newValue) {
        this.setAttribute('largeSrc', newValue);
      }
      set xlargeSrc(newValue) {
        this.setAttribute('xlargeSrc', newValue);
      }
      set hdSrc(newValue) {
        this.setAttribute('hdSrc', newValue);
      }
      set poster(newValue) {
        this.setAttribute('poster', newValue);
      }

      /* Called when removed from DOM */
      disconnectedCallback() {

        /* Removing event listeners */
        window.removeEventListener('resize', this.resizeEvent);
      }

        /* Method */

        //determines which source to use
        determineVideoSrc(){
            var windowWidth = window.innerWidth;

            //check if tiny breakpoint should be used
            if(windowWidth < this.smallBreakpoint){
                //track which breakpoint is being used
                this.usingBreakpointWidth = this.tinyBreakpoint;
                //add the video source
                this.addSourceToVideo(this.tinySrc);

            //check if small breakpoint should be used
            }else if(windowWidth >= this.smallBreakpoint && windowWidth < this.mediumBreakpoint){
                //track which breakpoint is being used
                this.usingBreakpointWidth = this.smallBreakpoint;
                //add the video source
                this.addSourceToVideo(this.smallSrc);

            //check if medium breakpoint should be used
            }else if(windowWidth >= this.mediumBreakpoint && windowWidth < this.largeBreakpoint){
                //track which breakpoint is being used
                this.usingBreakpointWidth = this.mediumBreakpoint;
                //add the video source
                this.addSourceToVideo(this.mediumSrc);

            //check if large breakpoint should be used
            }else if(windowWidth >= this.largeBreakpoint && windowWidth < this.xlargeBreakpoint){
                //track which breakpoint is being used
                this.usingBreakpointWidth = this.largeBreakpoint;
                //add the video source
                this.addSourceToVideo(this.largeSrc);

            //check if xlarge breakpoint should be used
            }else if(windowWidth >= this.xlargeBreakpoint && windowWidth < this.hdBreakpoint){
                //track which breakpoint is being used
                this.usingBreakpointWidth = this.xlargeBreakpoint;
                //add the video source
                this.addSourceToVideo(this.xlargeSrc);

            //check if hd breakpoint should be used
            }else if(windowWidth >= this.hdBreakpoint){
                //track which breakpoint is being used
                this.usingBreakpointWidth = this.hdBreakpoint;
                //add the video source
                this.addSourceToVideo(this.hdSrc);
            }

        }

        //adds the source to the video
        addSourceToVideo(srcToUse) {

            //console.log('setting source to '+srcToUse);

            //sets the correct source src on the video element
            this.source.setAttribute('src',srcToUse);

            //reload the video with the new source
            this.video.load();
        }

        //when the window is resized
        resizeEvent(e) {

            //wait until resize is finished to adjust
            clearTimeout(this.resizedFinished);
            this.resizedFinished = setTimeout(this.adjustAfterResize, 250)
        }

        //determine if a higher resolution video is required
        adjustAfterResize(){
            //console.log('resize finished');
            //console.log('window width:'+window.innerWidth);
            //console.log('using breakpoint width:'+this.usingBreakpointWidth);

            //if window width is bigger than the current breakpoint get a bigger video
            if(window.innerWidth > this.usingBreakpointWidth){
                this.determineVideoSrc();
            };
        }
        play(){
            this.video.play();
        }
        pause(){
            this.video.pause();
        }
        setTime(time){
          this.video.currentTime = time;
        }
        getTime(){
          return this.video.currentTime;
        }

    } /* END class */

    window.customElements.define('np-responsive-video', NpResponsiveVideo);

  })();
